export default "__VITE_ASSET__a92bd1bb__"